{
  "confirmationNumber": "Số xác nhận {number}",
  "dateTimeRange": "{date} từ {startTime} đến {endTime}"
}
